<template>
  <div class="content">
    <div class="row">
      <div class="main col-md-6 col-md-offset-3 offset-md-3 col-sm-6 col-sm-offset-3 offset-sm-3">
        <div v-if="!loading && !hasData">
          <h3 class="title">There is nothing to Approve</h3>
          <p class="message">Please go to dashboard for updated information.</p>
          <ed-button class="pull-right" @click="gotoDashboard">Go to Dashboard</ed-button>
        </div>
        <div v-else>
          Loading approval queue ...
        </div>

        <approveDialog :showModal="showApproveDialog"
                      :list="cards"
                      @close="gotoDashboard"
                      @approve="doApprove"  />
      </div>
    </div>
  </div>
</template>

<script>
  import approveDialog from './widgets/ApprovalNeeded/approve-dialog'

  export default {
    alias: 'ApproveAll',

    data() {
      return {
        loading: false,
        dataUrl: null,
        approveUrl: null,
        showApproveDialog: false,
        cards: []
      }
    },

    computed: {
      hasData() {
        return ((this.cards !== null) && (this.cards.length > 0))
      }
    },

    created() {
      this.reload()
    },

    methods: {
      reload() {
        this.loading = true

        this.api.get(this.api.$.dashboard.widgetInfo + '/2845D6A6-F692-493C-83DF-BACD8D349BC8', {})
          .then(rd => {
            this.dataUrl = rd.data.endPoint
            this.approveUrl = this.dataUrl.replace(/GetApprovalNeededList/, 'Approve')

            let params = this.$route.query.batchId > 0
              ? { params: { batchId: +this.$route.query.batchId } }
              : {}

            this.api.get(this.dataUrl, params)
              .then(r => {
                this.cards = r.data.items

                if (this.hasData) {
                  this.showApproveDialog = true
                }
              })
              .finally(() => { this.loading = false })
          })
      },

      doApprove(reason) {
        this.loading = true

        this.api.post(this.approveUrl, {
          list: this.getIdsList(),
          reason: reason,
          batchId: this.$route.query.batchId > 0 ? this.$route.query.batchId : null
        })
          .finally(() => {
            this.loading = false
            this.gotoDashboard()
          })
      },

      gotoDashboard() {
        this.$router.push('/home')
      },

      getIdsList() { return this.cards.map((item) => item.Id) }
    },

    components: { approveDialog }
  }
</script>

<style lang='scss'>
  @import "~@/assets/sass/_variables.scss";

  .main {
    @include theme {
      background: v(canvas);
      border: 1px solid v(border);
    }

    padding: 1rem;
    border-radius: $border-radius;
  }

  h3.title {
    font-weight: $font-weight-extra-bold;
    font-size: $font-size-large;
    margin-top: 0;
    margin-bottom: 0.5rem;
    text-transform: capitalize;
  }

  .message {
    font-weight: normal;
    font-size: $font-size-base;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/approve-all.vue